<div class="modal-body justify-content-center">
  <div class="cm-header-section">
    <h5 class="modal-title" id="costumesRentalsModalLabel">{{constants.modalTitle}}</h5>
    <button (click)="closeModal()" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
      <span class="cm-close-text">{{constants.close}}</span>
    </button>
  </div>

  <div class="si-container">
    <app-studio-inquiry-sidebar [activeStep]="3"></app-studio-inquiry-sidebar>

    <form class="si-application" [formGroup]="rentalsForm" (ngSubmit)="onNext()">
      <p class="cr-skip-banner">{{constants.skipBanner}}</p>

      <div class="si-section">
        <h2 class="si-section-title">{{constants.pullingInformation}}<span class="star-red">*</span></h2>

        <div class="cr-block">
          <h3 class="si-question">{{constants.descriptionQuestion}}</h3>
          <textarea class="form-control common-text-area cr-textarea" id="description" formControlName="description"
            [placeholder]="constants.descriptionPlaceholder" rows="4"></textarea>
        </div>

        <div class="cr-row">
          <h3 class="si-question">{{constants.pullDateQuestion}}</h3>
          <div class="custom-floating-label si-field cr-date-field">
            <label for="pullDate" class="form-label">{{constants.pullDate}}</label>
            <div class="input-group">
              <input class="form-control" id="pullDate" formControlName="pullDate" [placeholder]="getPlaceholder()"
                [firstDayOfWeek]="calenderFormat" ngbDatepicker #pullDatePicker="ngbDatepicker" />
              <button class="btn btn-outline-secondary bi bi-calendar3 custom-button-datepicker" type="button"
                [attr.aria-label]="constants.pullDate" (click)="pullDatePicker.toggle()"></button>
            </div>
          </div>
        </div>

        <div class="cr-row">
          <h3 class="si-question">{{constants.racksQuestion}}</h3>
          <div class="cr-rack-group">
            <div class="cr-rack-option" *ngFor="let option of constants.rackOptions; let i = index">
              <input type="radio" class="cr-rack-input" name="racks" formControlName="racks" [id]="'racks-' + i"
                [value]="option" />
              <label class="cr-rack-label" [for]="'racks-' + i">{{option}}</label>
            </div>
          </div>
        </div>

        <div class="cr-row">
          <h3 class="si-question">{{constants.visitQuestion}}</h3>
          <div class="cr-options">
            <div class="common-radio-btn" *ngFor="let option of constants.yesNoOptions; let i = index">
              <input class="common-radio-input mb-0" type="radio" name="visitCollection"
                formControlName="visitCollection" [id]="'visitCollection-' + i" [value]="option" />
              <label class="common-radio-label" [for]="'visitCollection-' + i">{{option}}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="si-section">
        <h2 class="si-section-title">{{constants.contactInformation}}<span class="star-red">*</span></h2>

        <div class="cr-row">
          <h3 class="si-question">{{constants.contactTypeQuestion}}</h3>
          <div class="cr-options">
            <div class="common-radio-btn" *ngFor="let type of constants.contactTypes; let i = index">
              <input class="common-radio-input mb-0" type="radio" name="primaryContactType"
                formControlName="primaryContactType" [id]="'primaryContactType-' + i" [value]="type" />
              <label class="common-radio-label" [for]="'primaryContactType-' + i">{{type}}</label>
            </div>
          </div>
        </div>

        <div class="cr-contact-grid">
          <div class="custom-floating-label si-field" *ngFor="let field of constants.contactFields">
            <input type="text" class="form-control" [id]="field.id" [formControlName]="field.id"
              [placeholder]="field.label" maxlength="50" />
            <label [for]="field.id" class="form-label">{{field.label}}</label>
          </div>
        </div>

        <div class="cr-block cr-block-tight">
          <div class="cr-row">
            <h3 class="si-question">{{constants.cloudCheckInQuestion}}</h3>
            <div class="cr-options cr-options-wide">
              <div class="common-radio-btn" *ngFor="let option of constants.yesNoOptions; let i = index">
                <input class="common-radio-input mb-0" type="radio" name="cloudCheckIn" formControlName="cloudCheckIn"
                  [id]="'cloudCheckIn-' + i" [value]="option" />
                <label class="common-radio-label" [for]="'cloudCheckIn-' + i">{{option}}</label>
              </div>
            </div>
          </div>
          <p class="cr-note">{{constants.cloudCheckInNote}}</p>
        </div>

        <div class="cr-contact-links">
          <a class="si-link cr-link" tabindex="0">
            <img src="../assets/images/add-icon-blue.svg" alt="" class="si-link-icon">
            {{constants.addSecondaryContact}}
          </a>
          <a class="si-link cr-link" tabindex="0">
            <img src="../assets/images/add-icon-blue.svg" alt="" class="si-link-icon">
            {{constants.addAuthorizedShoppers}}
          </a>
        </div>

        <div class="cr-row">
          <h3 class="si-question">{{constants.shippedQuestion}}</h3>
          <div class="cr-options">
            <div class="common-radio-btn" *ngFor="let option of constants.yesNoOptions; let i = index">
              <input class="common-radio-input mb-0" type="radio" name="orderShipped" formControlName="orderShipped"
                [id]="'orderShipped-' + i" [value]="option" />
              <label class="common-radio-label" [for]="'orderShipped-' + i">{{option}}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="si-section">
        <h2 class="si-section-title">{{constants.addressSection}}<span class="star-red">*</span></h2>

        <div class="cr-address">
          <div class="custom-dropdown custom-floating-label si-field">
            <label for="country" class="form-label">{{constants.country}}</label>
            <select id="country" class="custom-select" formControlName="country" (change)="onCountryChange($event)">
              <option class="dropdown-option" value="" disabled selected hidden>{{constants.selectCountry}}</option>
              <option class="dropdown-option" *ngFor="let country of countries" [value]="country.countryId">
                {{country.countryName}}
              </option>
            </select>
          </div>

          <div class="cr-address-grid">
            <div class="custom-floating-label si-field cr-address-street">
              <input type="text" class="form-control" id="street" formControlName="street"
                [placeholder]="constants.street" maxlength="85" />
              <label for="street" class="form-label">{{constants.street}}</label>
            </div>

            <div class="custom-floating-label si-field">
              <input type="text" class="form-control" id="city" formControlName="city" [placeholder]="constants.city"
                maxlength="50" />
              <label for="city" class="form-label">{{constants.city}}</label>
            </div>

            <div class="custom-dropdown custom-floating-label si-field">
              <label for="state" class="form-label">{{constants.state}}</label>
              <select id="state" class="custom-select" formControlName="state">
                <option class="dropdown-option" value="" disabled selected hidden>{{constants.selectState}}</option>
                <option class="dropdown-option" *ngFor="let state of states" [value]="state.stateName">
                  {{state.stateName}}
                </option>
              </select>
            </div>

            <div class="custom-floating-label si-field">
              <input type="text" class="form-control" id="zipCode" formControlName="zipCode"
                [placeholder]="constants.zipCode" maxlength="12" />
              <label for="zipCode" class="form-label">{{constants.zipCode}}</label>
            </div>

            <div class="custom-floating-label si-field cr-address-phone">
              <input type="text" class="form-control" id="addressPhone" formControlName="addressPhone"
                [placeholder]="constants.addressPhone" maxlength="20" />
              <label for="addressPhone" class="form-label">{{constants.addressPhone}}</label>
            </div>
          </div>

          <div class="common-checkbox-button cr-checkbox">
            <input type="checkbox" id="billingDifferent" class="common-checkbox-input"
              formControlName="billingDifferent" />
            <label class="common-checkbox-label cr-checkbox-label" for="billingDifferent">
              {{constants.billingDifferent}}
            </label>
          </div>
        </div>

        <h3 class="si-question">{{constants.billingContact}}</h3>

        <div class="cr-billing-grid">
          <div class="custom-floating-label si-field">
            <input type="text" class="form-control" id="billingContactName" formControlName="billingContactName"
              [placeholder]="constants.billingContactPlaceholder" maxlength="50" />
            <label for="billingContactName" class="form-label">{{constants.billingContactName}}</label>
          </div>

          <div class="custom-floating-label si-field">
            <input type="text" class="form-control" id="billingEmail" formControlName="billingEmail"
              [placeholder]="constants.billingEmailPlaceholder" maxlength="80" />
            <label for="billingEmail" class="form-label">{{constants.billingEmail}}</label>
          </div>
        </div>
      </div>

      <div class="si-section">
        <h2 class="si-section-title">{{constants.paymentType}}<span class="star-red">*</span></h2>

        <div class="cr-block cr-block-tight">
          <div class="cr-options cr-payment-options">
            <div class="common-radio-btn" *ngFor="let option of constants.paymentOptions; let i = index">
              <input class="common-radio-input mb-0" type="radio" name="paymentType" formControlName="paymentType"
                [id]="'paymentType-' + i" [value]="option" />
              <label class="common-radio-label" [for]="'paymentType-' + i">{{option}}</label>
            </div>
          </div>

          <ng-container *ngIf="isLineOfCredit">
            <p class="cr-note">{{constants.lineOfCreditNote}}</p>

            <div class="common-checkbox-button cr-checkbox">
              <input type="checkbox" id="useBillingForAccountant" class="common-checkbox-input"
                formControlName="useBillingForAccountant" />
              <label class="common-checkbox-label cr-checkbox-label" for="useBillingForAccountant">
                {{constants.useBillingForAccountant}}
              </label>
            </div>

            <div class="cr-accountant-grid">
              <div class="cr-accountant-field">
                <label for="accountantName" class="cr-accountant-label">
                  {{constants.accountantName}}<span class="star-red">*</span>
                </label>
                <input type="text" class="form-control cr-accountant-input" id="accountantName"
                  formControlName="accountantName" maxlength="50" />
              </div>

              <div class="cr-accountant-field">
                <label for="accountantEmail" class="cr-accountant-label">
                  {{constants.accountantEmail}}<span class="star-red">*</span>
                </label>
                <input type="text" class="form-control cr-accountant-input" id="accountantEmail"
                  formControlName="accountantEmail" maxlength="80" />
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="si-buttons">
        <div class="si-back">
          <img src="../assets/images/blue-left-icon.svg" alt="" class="si-back-icon">
          <a class="text-link si-back-link" tabindex="0" (click)="onBack()" (keydown.enter)="onBack()"
            (keydown.space)="onBack()">{{constants.back}}</a>
        </div>
        <div class="cr-actions">
          <button type="button" class="btn common-btn-light" (click)="onSkip()">{{constants.skip}}</button>
          <button type="submit" class="btn common-btn-secondary"
            [disabled]="rentalsForm.invalid">{{constants.next}}</button>
        </div>
      </div>
    </form>
  </div>
</div>
